import i18n from 'i18n';
import moment from 'moment';

// Set local language
moment.locale(i18n.language);

export const CATCHUP_DAYS = 7;

export const EPG_DAYS = 13;

export const CALENDAR_ARROW_TYPES = {
	SUBTRACT: 'subtract',
	ADD: 'add'
};

//********************** Calendar **********************
export const localeOptions = {
	lang: {
		yearFormat: 'YYYY',
		monthFormat: 'MMMM',
		today: i18n.t('common_today'),
		now: i18n.t('common_now'),
		locale: 'pl_PL'
	}
};

export const setLocaleDate = (date) => moment(date).locale(i18n.language);

export const disabledDate = (current) => {
	// Can not select days before today and today
	const daysInFuture = moment().add(EPG_DAYS, 'days');
	const daysInPast = moment().subtract(CATCHUP_DAYS, 'days');
	return current < daysInPast || current > daysInFuture;
};

export const formatDateToCalendar = (date) => date.format('YYYY-MM-DD');
